import {fetchUserId} from 'backend/pos-shop';
import { fetch } from 'wix-fetch';

import wixUsers from 'wix-users';

$w.onReady(function () {
	// Write your code here
	// fetch('https://www.wix.com/_api/pos-tablet-shop/auth/identity', {
    //     method: 'GET',
    //     headers: { 'Accept': 'application/json' },
    //     credentials: 'include',
    //     cache: 'no-store'
    // })
    // fetchUserId()
	// .then(httpResponse => httpResponse)
	// .then((response) => {
	// 	console.log('fetchUserId response', response);
	// }).catch(e => {
	// 	console.error('fetchUserId error', e);
	// });
    // fetchUser();
    // console.log(wixUsers.currentUser);

});

export function fetchUser() {
    // return fetch('https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails', {
    //     method: 'GET',
    //     headers: { 'Accept': 'application/json' },
    //     credentials: 'include',
    //     cache: 'no-store'
    // })
    let user = fetchUserId();
    // console.log('fetchUser', user);
    // .then(response => {
    //     // console.log('response fetchUserId', response)
    //     return response.json()
    // })
    // .then(data => {
    //     console.log('data fetchUserId', PushMessageData)
    //     // return httpResponse.json()
    // })
    // .catch(e => {
    //     console.error(e);
    // });
}